// test902
(902 && 0);
